import React, { useEffect, useState } from 'react';
import Modal from '../Modal';


import { BodyBox, ButtonWrap, CancelButton, DetailModalAddres, DetailModalAddress, DetailModalBox, DetailModalId, DetailModalInput, DetailModalItem, DetailModalItem1, DetailModalLabel, DetailModalLabel1, DetailModalLabel2, DetailModalSpan, ModalTitle, Popup, PopupBox, SaveButton } from './OrdersConfirm.styled';

import { useConfirmOrderMutation, useGetOrderQuery, useGetOrdersQuery } from '../../../redux/orders/ordersApi';

import { showErrorToast, showSuccessToast } from 'utils/showToast';

import FormatNumber from 'components/other/FormatNumber/FormatNumber';
import { useGetDishOrderQuery } from '../../../redux/dishorders/dishordersApi';

const getDishPreview = (orderDish, limit = 3) => {
  if (!orderDish?.data) {
    return { dishes: [], rest: 0 };
  }

  const dishesArray = Object.values(orderDish.data);
  const dishes = dishesArray.slice(0, limit);
  const rest = dishesArray.length - dishes.length;

  return { dishes, rest };
};
const getOptionsString = (options) => {
  if (!options || Array.isArray(options) && options.length === 0) {
    return '';
  }

  return Object.values(options)
    .map(opt => opt.name)
    .join(', ');
};
const OrdersConfirm = ({ onClose, orderArrayId,selectOrderCId,setSelectArrayOrderId }) => {
console.log('orderArrayId :>> ', orderArrayId);
  const [selectedPopup, setSelectedPopup] = useState(orderArrayId.find(item=>item.id===selectOrderCId));
 const isOrder = selectedPopup?.type === 'order';
const isDish = selectedPopup?.type === 'dish';
  console.log('selectedPopup :>> ', selectedPopup);
  const { data: order, isLoading: isLoadingOrder } = useGetOrderQuery(selectedPopup?.id, { skip: !isOrder });
    const { data: orderDish, isLoading: isLoadingOrderDish } = useGetDishOrderQuery(selectedPopup?.id, { skip: !isDish  });
  const [confirmOrder, ] = useConfirmOrderMutation();
const isLoading = isLoadingOrder || isLoadingOrderDish;
const currentData = isOrder ? order : orderDish;
const [showAllDishes, setShowAllDishes] = useState(false);

useEffect(() => {
   setSelectedPopup(orderArrayId.find(item=>item.id===selectOrderCId))
   

  }, [selectOrderCId,orderArrayId]);
  
  useEffect(() => {
    if (orderDish) console.log('orderDish :>> ', orderDish);
    if(order) console.log('order :>> ', order);

  }, [order,orderDish]);

//   const handleSave = async () => {

   
//     try {
//      const data= await confirmOrder(orderArrayId[0])
//       console.log('data :>> ', Number(data?.data?.status) < 300);
//       if (Number(data?.data?.status)<300) {
//         showSuccessToast('Кошик видано')
//         onClose();
//       } else {
//         console.log('dataewqdrwq :>> ', data);
//         showErrorToast(data?.error?.data?.message ? data?.error?.data?.message :'Помилка')
//         data.error.data.details.map(item => showErrorToast(item))
        
// }
        
//       console.log('Details  successfully');
   


//     } catch (error) {
//       console.error('Failed to Details:', error);
//       console.log('error :>> ', error);
//       showErrorToast("Помилка")
//     }
//     onClose();
//   };




  const handleSave = async () => {
  try {
    if (isOrder) {
      const res = await confirmOrder(selectedPopup.id);
      if (Number(res?.data?.status) < 300) {
        showSuccessToast('Замовлення видано');
        onClose();
        return;
      }
    }

    if (isDish) {
      // приклад, якщо буде окремий confirm
      // await confirmDishOrder(selectedPopup.id);
      showSuccessToast('Страву видано');
      onClose();
      return;
    }

    showErrorToast('Помилка');
  } catch (e) {
    showErrorToast('Помилка');
  }
};

  return (

    <Modal pad={'false'} onClose={onClose} loading={isLoading?0:1}>
      <PopupBox>
        {orderArrayId.map(item => {
          return (
            <Popup
              count={orderArrayId.length < 8 ? orderArrayId.length : 7}
               className={
                          item.id === selectedPopup.id && item.type === selectedPopup.type
                            ? 'activepopup'
                            : null
                        }
              key={`${item.type}-${item.id}`}
              onClick={() => {
    
                setSelectedPopup(item);
                 setShowAllDishes(false); 
            }}>
              {item.id}
            </Popup>
          )
        })}
      </PopupBox>
      <BodyBox>
      <ModalTitle>Видати замовлення</ModalTitle>
          {isOrder && order && (
  <DetailModalBox>
    <DetailModalAddress>
      {order.shop.name} ({order.shop.address})
    </DetailModalAddress>

    <DetailModalId>
      <FormatNumber
        number={order.key}
        color={'var(--colors-secondary-25)'}
      />
    </DetailModalId>

    <DetailModalItem>
      <DetailModalLabel>{order.bag.name}</DetailModalLabel>
      <DetailModalSpan>{order.count} шт</DetailModalSpan>
    </DetailModalItem>
  </DetailModalBox>
)}

{/* ===== ORDER DISH ===== */}
{isDish && orderDish && (() => {
const allDishes = Object.values(orderDish.data || {});
const preview = showAllDishes
  ? { dishes: allDishes, rest: 0 }
  : getDishPreview(orderDish);
  return (
    <DetailModalBox>
      <DetailModalAddress>
        {orderDish.shop.name} ({orderDish.shop.address})
      </DetailModalAddress>

      <DetailModalId>
        <FormatNumber
          number={orderDish.key}
          color={'var(--colors-secondary-25)'}
        />
      </DetailModalId>

    {preview.dishes.map(dish => {
  const optionsText = getOptionsString(dish.options);

  return (
    <DetailModalItem1 key={dish.id}>
      <div>
        <DetailModalLabel>{dish.name}</DetailModalLabel>

        {optionsText && (
          <DetailModalLabel2>
            {optionsText}
          </DetailModalLabel2>
        )}
      </div>

      <DetailModalSpan>{dish.count} шт</DetailModalSpan>
    </DetailModalItem1>
  );
})}

    {preview.rest > 0 && (
      <DetailModalLabel1
        style={{ cursor: 'pointer' }}
        onClick={() => setShowAllDishes(true)}
      >
        ще {preview.rest}...
  </DetailModalLabel1>
)}
    </DetailModalBox>
  );
})()}
      <ButtonWrap>
      
          <SaveButton  onClick={() => {
    // 🔹 фільтруємо масив, видаляючи виділений елемент
    const newArray = orderArrayId.filter(
      item =>
        !(item.id === selectedPopup.id && item.type === selectedPopup.type)
    );

    // 🔹 оновлюємо стан у батьківському компоненті
    setSelectArrayOrderId(newArray);

    // 🔹 закриваємо модалку
    onClose();
  }} >Видано отримувачу</SaveButton> 
          </ButtonWrap>
      </BodyBox>
    </Modal>
     
  );
};

export default OrdersConfirm;